function Pollytts(settings_params) {
    // include Polly from aws sdk.
    var Polly = require('aws-sdk/clients/polly');

    // presigner for Polly
    var presigner = new Polly.Presigner({
        region: settings_params.awsRegion,
        credentials: {
            accessKeyId: 'AKIASZTLHW7PWMLN5KVP',
            secretAccessKey: '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'
        }
    });

    var TTS = {
        self: this,
        playlist: [],
        getAudioUrl: function(msg, VoiceId, ElementId) {
           
            var url = presigner.getSynthesizeSpeechUrl({
                TextType: 'text',
                OutputFormat: 'mp3',
                VoiceId: VoiceId,
                Text: msg
            });
            var audioElement = document.getElementById(ElementId);
            if (!!audioElement) {
                audioElement.src = url;
            }
        }

    }
    return TTS;
}

export default Pollytts;